import ApiService from "./api.service";

const Announcements = {
  create: async function (announcement) {
    let response = await ApiService.post("/announcement", announcement);
    return response.data;
  },
  update: async function (announcementId, announcement) {
    let response = await ApiService.put("/announcement/" + announcementId, announcement);
    return response.data;
  },
  load: async function (boardName) {
    let response = await ApiService.get("/announcements/" + boardName);
    return response.data.announcements;
  },
  delete: async function (announcementId, ) {
    await ApiService.delete("/announcement/" + announcementId);
    return true;
  }
};

export default Announcements;